import { NotificationSubscription } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

declare const abp: any;

export const useOrderNotification = () => {
  const { orderStore, requestStore } = useStore();
  const {
    applyOrderToPanel,
    removeCalendarOrder,
    removeUnassignedServiceOrder,
    addOrUpdateCalendarOrder,
    updateOrdersStatus,
  } = orderStore;

  const { addRequest, filterRequestSidePanel } = requestStore;

  useEffect(() => {
    abp.event.on('abp.notifications.received', (userNotification: any) => {
      const notificationName = userNotification.notification.notificationName;
      const result = userNotification.notification.data.properties;

      switch (notificationName) {
        case NotificationSubscription.RequestCreated:
          addRequest(result);
          break;
        case NotificationSubscription.OrderCreated:
          // Scheduled means dated, as the API's calendar/unassigned split does: a job can be on a day
          // before it has a technician. The panel decides for itself whether the job belongs on the
          // list it is showing (no day, or a day with no technician) - an estimate or a draft is open
          // work like any other, so it is no exception.
          if (result.startAt) addOrUpdateCalendarOrder(result);
          applyOrderToPanel(result);
          filterRequestSidePanel(result.requestId);
          break;
        case NotificationSubscription.OrderUpdated:
          // Routed by date for the calendar; the panel applies its own rule, so a job given a
          // technician leaves the Unassigned list and one with its technician cleared joins it,
          // and an update to a waiting job never pushes it onto the calendar with no start.
          if (result.startAt) addOrUpdateCalendarOrder(result);
          else removeCalendarOrder(result.id);
          applyOrderToPanel(result);
          // The job open on the card may have been moved on from elsewhere (completed, paused...).
          orderStore.applyServerStatus(result.id, result.status);
          break;
        case NotificationSubscription.OrderDeleted:
          removeCalendarOrder(result.id);
          removeUnassignedServiceOrder(result.id);
          break;
        case NotificationSubscription.OrderUnassigned:
          // Taken off the calendar altogether (the drawer's Unassign): no day any more.
          removeCalendarOrder(result.id);
          applyOrderToPanel({ ...result, startAt: null });
          break;
        case NotificationSubscription.OrdersStatusUpdate:
          updateOrdersStatus(result.orders, result.status);
          break;
        default:
          break;
      }
    });
  }, []);
};
